import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { GALLERY } from "./siteData";
import { Reveal } from "./Reveal";

const ParallaxImg = ({ src, idx, range }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [range, -range]);
  const scale = useTransform(scrollYProgress, [0, 0.5, 1], [1.12, 1, 1.12]);

  return (
    <div
      ref={ref}
      className={`overflow-hidden rounded-xl border border-white/10 ${
        idx === 0 ? "col-span-2 row-span-2" : ""
      } ${idx === 3 ? "md:row-span-2" : ""}`}
    >
      <motion.img
        src={src}
        alt={`Gym ${idx + 1}`}
        data-testid={`gallery-image-${idx}`}
        style={{ y, scale }}
        className="w-full h-full object-cover will-change-transform"
      />
    </div>
  );
};

export const Gallery = () => {
  return (
    <section id="gallery" data-testid="gallery-section" className="bg-black py-20 md:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center max-w-2xl mx-auto mb-14">
          <span className="text-gold font-semibold uppercase tracking-[0.25em] text-sm">
            Inside The Gym
          </span>
          <h2 className="font-bebas text-5xl sm:text-6xl text-white mt-3 leading-none">
            Feel The Energy
          </h2>
        </Reveal>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 auto-rows-[180px] md:auto-rows-[220px]">
          {GALLERY.map((src, i) => (
            <ParallaxImg key={i} src={src} idx={i} range={i % 2 === 0 ? 30 : 50} />
          ))}
        </div>
      </div>
    </section>
  );
};
